import { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { ButtonPrimary } from '../../../../../baseComponents/Button'
import { WidgetDictionary } from '../../../../../baseComponents/Dashboard/useDashboardWidgets/types'
import SingleCategoryDashboard from '../../../../../baseComponents/SingleCategoryDashboard'
import { InputTableURLsTable } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { TableConfiguration } from '../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { OnSubmit } from '../../../../../forms/TwinForm/types'
import { SetTPVCompleteDataTy, TPVOrderData } from '../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../utils/globals/dictionary'
import useSellTicketHeaderUrls from '../../../../../utils/hooks/sells/orders/useSellTicketHeaderUrls'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getEmployeeParams, getISOCurrencyMain, getUserInfo } from '../../../../../utils/reducers/getters'
import LastAddedProductTPVDSB from './Components/LastAddedProductTPVDSB'
import ProductCategoriesTPVDSB from './Components/ProductCategoriesTPVDSB'
import ProductTicketTPVDSB from './Components/ProductTicketTPVDSB'
import SellerDataTPVDSB from './Components/SellerDataTPVDSB'
import SellTicketSearcherTPVDSB from './Components/SellTicketSearcherTPVDSB'
import ModalWorkingCenterSelector from './ModalWorkingCenterSelector'
import { SetTPVWorkingCenterInfoTy, TPVWorkingCenterInfoTy } from './types'
import { UserModel } from '../../../../../utils/reducers/globals/user'
import { getTPVWorkingCenterAndStep, parsedTicketTableData } from './functions'
import LoadingSpinner from '../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import MoneyCashInOutTPVDSB from './Components/MoneyCashInOutTPVDSB'
import { changeMultiUser, deleteAntiUnsaveElement } from '../../../../../utils/reducers/reduxDispatch'
import { AllReduxAppPayloads, GlobalContext } from '../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import { ProductModelType } from '@teinor/erp/types/company/product'
import ModalCloseCashRegister from './ModalCashRegister/ModalCloseCashRegister'
import ModalOpenCashRegister from './ModalCashRegister/ModalOpenCashRegister'
import CustomerDataTPVDSB from './Components/CustomerDataTPVDSB'
import CustomError from '../../../../../baseComponents/CustomError'
import { listenSocket, unlistenSocket } from '../../../../../utils/globals/socket'

const TPVDashboard: React.FC<ReduxTPVDashboardConnector> = (logic) => {
    const { t } = useTwinTranslation()
    const { completeData, setCompleteData, openModal, setOpenModal, workingCenterInfo, getCompleteData, inputTableURLs, handleOnSubmitCloseCashRegister, handleOnSubmitOpenCashRegister, setWorkingCenterInfo, workingCenters, user, addTicketProduct } = useTPVDashboardLogic(logic)
    const { allWidgets } = useTPVDashboardWidgetsLogic({ completeData, setCompleteData, setTableConfiguration: () => { }, tableConfiguration: {} as any, getCompleteData, inputTableURLs, addTicketProduct })
    const defaultStyle = getEmployeeParams()?.['appStyle'] || 'new1'
    const defaultWidgets = {
        default: [{ "cols": 3, "rows": 5, "name": "products_ticket_tpv" }, { "cols": 1, "rows": 2, "name": "customer_data_tpv" }, { "cols": 1, "rows": 2, "name": "last_product_added_tpv" }, { "cols": 2, "rows": 6, "name": "products_categories_tpv" }, { "cols": 1, "rows": 3, "name": "tpv_money_cash_in_out" }, { "cols": 1, "rows": 1, "name": "sell_ticket_searcher_tpv" }, { "cols": 1, "rows": 1, "name": "seller_data_tpv" }],
        new1: [{ "cols": 3, "rows": 5, "name": "products_ticket_tpv" }, { "cols": 1, "rows": 2, "name": "customer_data_tpv" }, { "cols": 1, "rows": 2, "name": "last_product_added_tpv" }, { "cols": 2, "rows": 6, "name": "products_categories_tpv" }, { "cols": 1, "rows": 3, "name": "tpv_money_cash_in_out" }, { "cols": 1, "rows": 1, "name": "sell_ticket_searcher_tpv" }, { "cols": 1, "rows": 1, "name": "seller_data_tpv" }]
    }
    
    const props = {
        name: 'dashboard_tpv',
        defaultWidgets: JSON.stringify(defaultWidgets[defaultStyle]),
        title: t('tpv', 'TPV'),
        allWidgets
    }
    if (workingCenterInfo?.step === 'noWorkingCenter') {
        return <TPVHeaderNoWorkingCenters user={user} />
    }
    if ((!completeData || (workingCenterInfo?.step === 'checkCashRegister' && !completeData?.cashRegister))) {
        return <LoadingSpinner/>
    }
    if (!completeData?.cashRegister?.id) {
        return (
            <div className='flex flex-auto flex-col'>
                <TPVHeaderInfo user={user} workingCenterInfo={workingCenterInfo} setWorkingCenterInfo={setWorkingCenterInfo}/>
                <div className='flex-auto'>
                    <ButtonPrimary className='w-200 m-auto' onClick={() => setOpenModal({type: 'create', allRowData: {}})}><TwinTrans transKey='openCashRegister'>Abrir caja</TwinTrans></ButtonPrimary>
                </div>
                {openModal?.type === 'create' ? <ModalOpenCashRegister setOpened={() => setOpenModal(null)} onSubmit={handleOnSubmitOpenCashRegister} MyWorkingCenter={workingCenters[workingCenterInfo?.MyWorkingCenterId || 0]} MyWorkingCenterStationId={workingCenterInfo?.MyWorkingCenterStationId} MyWorkingCenterId={workingCenterInfo?.MyWorkingCenterId} /> : null}
                {workingCenterInfo?.step === 'askWorkingCenter' ? <ModalWorkingCenterSelector setOpened={() => {
                    setWorkingCenterInfo((old) => {
                        const copyOld = JSON.parse(JSON.stringify(old))
                        copyOld.step = 'openCashRegister'
                        return copyOld
                    })
                }} onSubmit={() => {}} setWorkingCenterInfo={setWorkingCenterInfo} workingCenterInfo={workingCenterInfo}/> : null}
            </div>
        )
    }
    return (
        <Fragment>
            <SingleCategoryDashboard {...props} forceFamily='tpv' RightHeader={<ButtonPrimary onClick={() => setOpenModal({ type: 'edit', allRowData: { ...completeData } })} className='ml-10' key='buttonHeaderDashboard'><TwinTrans transKey={'closeCashRegister'}>Cerrar Caja</TwinTrans></ButtonPrimary>} />
            {openModal?.type === 'edit' ? <ModalCloseCashRegister setOpened={() => setOpenModal(null)} onSubmit={handleOnSubmitCloseCashRegister} MyWorkingCenter={workingCenters[completeData?.cashRegister?.WorkingCenterId || 0]} allRowData={openModal.allRowData} MyWorkingCenterStationId={completeData?.cashRegister?.WorkingCenterStationId} /> : null}
        </Fragment>
    )
}

interface TPVDashboardWidgetsLogicProps {
    completeData: TPVOrderData | null
    setCompleteData: SetTPVCompleteDataTy
    getCompleteData: () => Promise<void>
    tableConfiguration: TableConfiguration
    setTableConfiguration: React.Dispatch<React.SetStateAction<TableConfiguration>>
    inputTableURLs: InputTableURLsTable
    addTicketProduct: (product: ProductModelType) => Promise<void>
}

const useTPVDashboardWidgetsLogic = ({ ...rest}: TPVDashboardWidgetsLogicProps) => {
    const { t } = useTwinTranslation()
  
    const orderHeaderURLs = useSellTicketHeaderUrls()
    const DSBWidgetTitlesTranslatedParsed = JSON.stringify({
        tpv_last_added_product: t('lastAddedProduct', 'Último producto añadido'),
        tpv_ticket: t('yourTicket', 'Tu ticket'),
        tpv_customer_data: t('customerData', 'Datos del cliente'),
        tpv_seller_data: t('sellerData', 'Datos del vendedor'),
        tpv_product_catalog: t('catalog', 'Catálogo'),
        sell_ticket_searcher_tpv: t('tickets', 'Tickets'),
        tpv_money_cash_in_out: t('cashInOut', 'Entrada y salida de caja'),
    })

    const DSBWidgetTitlesTranslated = JSON.parse(DSBWidgetTitlesTranslatedParsed)
    const allWidgets: WidgetDictionary = {
        'customer_data_tpv': {
            component: CustomerDataTPVDSB,
            cols: 1,
            rows: 3,
            permission: 'sell.tickets',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.tpv_customer_data,
                ...rest
            },
            family: 'tpv'
        },
        'seller_data_tpv': {
            component: SellerDataTPVDSB,
            cols: 2,
            rows: 1,
            permission: 'sell.tickets',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.tpv_seller_data,
                ...rest
            },
            family: 'tpv'
        },
        'last_product_added_tpv': {
            component: LastAddedProductTPVDSB,
            cols: 1,
            rows: 2,
            permission: 'sell.tickets',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.tpv_last_added_product,
                ...rest
            },
            family: 'tpv'
        },
        'products_categories_tpv': {
            component: ProductCategoriesTPVDSB,
            cols: 2,
            rows: 3,
            permission: 'product.profile.main',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.tpv_product_catalog,
                CustomerId: rest.completeData?.header?.CustomerId || rest.completeData?.Customer?.id,
                OrderId: rest.completeData?.header?.id,
                ...rest,
            },
            family: 'tpv'
        },
        'products_ticket_tpv': {
            component: ProductTicketTPVDSB,
            cols: 2,
            rows: 5,
            permission: 'product.profile.main',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.tpv_ticket,
                orderHeaderURLs,
                ...rest
            },
            family: 'tpv',
            className: 'tpv_ticket'
        },
        'sell_ticket_searcher_tpv': {
            component: SellTicketSearcherTPVDSB,
            cols: 1,
            rows: 1,
            permission: 'sell.tickets',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.sell_ticket_searcher_tpv,
                ...rest
            },
            family: 'tpv',
        },
        'tpv_money_cash_in_out': {
            component: MoneyCashInOutTPVDSB,
            cols: 1,
            rows: 2,
            permission: 'sell.tickets',
            modules: ['tpv'],
            extraProps: {
                title: DSBWidgetTitlesTranslated.tpv_money_cash_in_out,
                ...rest
            },
            family: 'tpv',
        }
    }

    return { allWidgets }
}

interface TPVDashboardLogicProps extends ReduxTPVDashboardConnector {

}

const useTPVDashboardLogic = ({ EmployeeWorkingCenterId, EmployeeWorkingCenterStationId, dateLastChange, subTypeUser }: TPVDashboardLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [completeData, setCompleteData] = useState<TPVOrderData | null>(null)
    const user = useMemo(() => getUserInfo(), [])
    const workingCenters = useMemo(() => dictionaryComplexFromJsonArr(user?.WorkingCenters || []), [user?.WorkingCenters]) 
    const [workingCenterInfo, setWorkingCenterInfo] = useState<TPVWorkingCenterInfoTy | null>(null)
    const myId = completeData?.header?.id
    const currency = getISOCurrencyMain()
    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/order/tpv/sellTicket/orderProduct/createSellTicketProduct', { OrderId: completeData?.header?.id, WorkingCenterId: completeData?.cashRegister?.WorkingCenterId || workingCenterInfo?.MyWorkingCenterId, CurrencyId: currency, CashRegisterId: completeData?.cashRegister?.id, CustomerId: completeData?.header?.CustomerId || completeData?.Customer?.id, WorkingCenterStationId: completeData?.cashRegister?.WorkingCenterStationId || workingCenterInfo?.MyWorkingCenterStationId}],
        getData: ['/api/app/order/tpv/sellTicket/getSellTicketComplete', {id: completeData?.header?.id, full_assigned_number: completeData?.header?.full_assigned_number}],
        updateData: '/api/app/order/tpv/sellTicket/orderProduct/updateSellTicketProduct',
        delete: '/api/app/order/tpv/sellTicket/orderProduct/deleteSellTicketProduct',
        updateHeaderData: '/api/app/order/tpv/sellTicket/updateSellTicket',
        getSubProducts: ['/api/app/order/tpv/sellTicket/orderProduct/getAllSubSellTicketProducts', ['CustomerId']],
        updateOrderLines: '/api/app/order/tpv/sellTicket/updateSellTicketNLines',
        printTags: '/api/app/order/tpv/sellTicket/printSellTicketTags'
    }

    const getOpenCashRegister = useCallback(async () => {
        if (workingCenterInfo?.MyWorkingCenterId) {
            let TPVBaseData: TPVOrderData = {
                dictPosTableData: {},
                filters: {} as any,
                header: {},
                originalTableData: [],
                tableData: [],
                cashRegister: {} as any,
                lastProductIndex: null,
                Customer: {} as any,
                discountsWithVat: true
            }
            const result = await twinFetchPostJSON('/api/app/order/tpv/cashRegister/getOpenCashRegister', { WorkingCenterId: workingCenterInfo?.MyWorkingCenterId, WorkingCenterStationId: workingCenterInfo?.MyWorkingCenterStationId })
            if (result && result.id) {
                TPVBaseData.cashRegister = result
                setCompleteData(() => {
                    const myTpvBaseCopy = JSON.parse(JSON.stringify(TPVBaseData))
                    parsedTicketTableData(myTpvBaseCopy)
                    return myTpvBaseCopy
                })
            } else {
                setWorkingCenterInfo((old) => {
                    const copyOld = JSON.parse(JSON.stringify(old))
                    copyOld.step = 'openCashRegister'
                    return copyOld
                })
                setCompleteData(() => {
                    return TPVBaseData
                })
            }
        }
    }, [workingCenterInfo?.MyWorkingCenterId, setCompleteData, workingCenterInfo?.MyWorkingCenterStationId, setWorkingCenterInfo])

    const getCompleteData = useCallback(async (myPropId?: number, updateLastProduct?: boolean) => {
        const getDataStr = JSON.stringify(inputTableURLs.getData)
        const getDataParsed = JSON.parse(getDataStr)
        const subId = myPropId || myId
        let result: TwinDictionary = {}
        if (subId) {
            result = await twinFetchPostJSON(getDataParsed[0], { id: subId, includeRelations: true })
        } else {
            await deleteAntiUnsaveElement('sellTicket')
        }
        setCompleteData((old) => {
            let copyOld = JSON.parse(JSON.stringify(old))
            copyOld.tableData = result?.tableData
            copyOld.header = result?.header
            copyOld.Customer = old?.Customer
            copyOld = parsedTicketTableData(copyOld, undefined, updateLastProduct)
            return copyOld
        })
    }, [setCompleteData, inputTableURLs.getData, myId])

    const handleOnSubmitCloseCashRegister: OnSubmit = useCallback(async (res) => {
        const responseJSON = await res.json()
        if (responseJSON) {
            setCompleteData({
                dictPosTableData: {},
                filters: {} as any,
                header: {},
                originalTableData: [],
                tableData: [],
                cashRegister: {} as any,
                lastProductIndex: null,
                Customer: {} as any,
                discountsWithVat: true
            })
            if (subTypeUser === 'temporal') {
                changeMultiUser(true)
            }
            setOpenModal(null)
        }
    }, [setCompleteData, subTypeUser, setOpenModal])

    const handleOnSubmitOpenCashRegister: OnSubmit = useCallback(async (res) => {
        const responseJSON = await res.json()
        if (responseJSON.id) {
            let TPVBaseData: TPVOrderData = {
                dictPosTableData: {},
                filters: {} as any,
                header: {},
                originalTableData: [],
                tableData: [],
                cashRegister: responseJSON,
                lastProductIndex: null,
                Customer: {} as any,
                discountsWithVat: true
            }
            setCompleteData(() => {
                const myTpvBaseCopy = JSON.parse(JSON.stringify(TPVBaseData))
                parsedTicketTableData(myTpvBaseCopy)
                return myTpvBaseCopy
            })
            setOpenModal(null)
        }
    }, [setCompleteData, setOpenModal])

    const addTicketProduct = useCallback(async (product: ProductModelType) => {
        let myOrderId = null
        if (!completeData?.header?.readOnly) {
            myOrderId = completeData?.header?.id
        }
        const newProduct = await twinFetchPostJSON(inputTableURLs.createData[0], { ...inputTableURLs.createData[1], ProductId: product.id, SuperProductParentId: product.ProductId, uniqueNumber: product.unique_number, CustomerId: completeData?.header?.CustomerId || completeData?.Customer?.id, OrderId: myOrderId })
        await getCompleteData(newProduct?.OrderId, true)
    }, [inputTableURLs.createData, getCompleteData, completeData])

    useEffect(() => {
        if (workingCenterInfo?.step === 'checkCashRegister') {
            getOpenCashRegister()
        }
    }, [getOpenCashRegister, workingCenterInfo?.step])

    useEffect(() => {
        setWorkingCenterInfo(getTPVWorkingCenterAndStep(EmployeeWorkingCenterId, EmployeeWorkingCenterStationId, user))
    }, [EmployeeWorkingCenterId, EmployeeWorkingCenterStationId, user])

    useEffect(() => {
        const now = new Date()
        if (dateLastChange){
            const parsedDateLastChange = new Date(dateLastChange)
            if (subTypeUser === 'temporal' && dateLastChange && now.getTime() - parsedDateLastChange?.getTime() > 3000){
                changeMultiUser(true)
            }
            return ()=>{
                const newNow = new Date()
                if (subTypeUser === 'temporal' && dateLastChange && newNow.getTime() - parsedDateLastChange?.getTime() > 3000) {
                    changeMultiUser(true)
                }
            }
        }
    }, [dateLastChange, subTypeUser])

    useEffect(() => {
        if(workingCenterInfo?.MyWorkingCenterId){
            const key = 'getCashRegister_' + (workingCenterInfo?.MyWorkingCenterId) + '_'+(workingCenterInfo?.MyWorkingCenterStationId || 0)
            listenSocket(key, getOpenCashRegister, true)
            return () => {
                unlistenSocket(key)
            }
        }
    }, [getOpenCashRegister, workingCenterInfo?.MyWorkingCenterId, workingCenterInfo?.MyWorkingCenterStationId])

    return { completeData, setCompleteData, openModal, setOpenModal, getCompleteData, inputTableURLs, handleOnSubmitCloseCashRegister, handleOnSubmitOpenCashRegister, workingCenterInfo, setWorkingCenterInfo, workingCenters, user, addTicketProduct }
}

interface TPVHeaderInfoProps extends TPVHeaderInfoLogicProps {}

const TPVHeaderInfo: React.FC<TPVHeaderInfoProps> = ({ user, workingCenterInfo, setWorkingCenterInfo}) => {
    const { tVars } = useTwinTranslation()
    const { workingCenterStations, handleChangeWorkingCenter } = useTPVHeaderInfoLogic({ user, workingCenterInfo, setWorkingCenterInfo })
    const MyWorkingCenterStationText = workingCenterInfo?.MyWorkingCenterStationId ?  tVars('youAreInWorkingCenterStationX', 'en el puesto {{workingCenterStationName}}', { workingCenterStationName: workingCenterStations[workingCenterInfo?.MyWorkingCenterStationId || 0]?.name })  : ''
    return (
        <div className='mx-auto text-center flex-auto content-center'>
            <h1>
                {tVars('helloName', 'Hola {{employeeName}}', { employeeName: user?.Employee?.fullname_short })}
            </h1>
            <div className='mt-30 regular14'>
                {tVars('youAreInWorkingCenterX', 'Te encuentras en el centro de trabajo de {{workingCenterName}}', { workingCenterName: user?.WorkingCenters?.[workingCenterInfo?.MyWorkingCenterId || 0]?.name })}
                <span> </span>
                {MyWorkingCenterStationText}
            </div>
            <div className='cursor-pointer medium14 text-green-43 mt-20' onClick={handleChangeWorkingCenter}><TwinTrans transKey='changeWorkingCenterOrStation'>Cambiar centro o puesto de trabajo</TwinTrans></div>
        </div>
    )
}

interface TPVHeaderInfoLogicProps {
    user: UserModel | undefined
    workingCenterInfo: TPVWorkingCenterInfoTy | null
    setWorkingCenterInfo: SetTPVWorkingCenterInfoTy
}

const useTPVHeaderInfoLogic = ({ user, workingCenterInfo, setWorkingCenterInfo }: TPVHeaderInfoLogicProps) => {
    const workingCenterStations = dictionaryComplexFromJsonArr(user?.WorkingCenters?.[workingCenterInfo?.MyWorkingCenterId || 0]?.WorkingCenterStations || [])
    const handleChangeWorkingCenter = useCallback(() => {
        setWorkingCenterInfo((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.step = 'askWorkingCenter'
            return copyOld
        })
    }, [setWorkingCenterInfo])
    return { handleChangeWorkingCenter, workingCenterStations }
}

interface TPVHeaderNoWorkingCentersProps { 
    user: UserModel | undefined
}

const TPVHeaderNoWorkingCenters: React.FC<TPVHeaderNoWorkingCentersProps> = ({ user }) => {
    const { t, tVars } = useTwinTranslation()
    return (
        <div className='mx-auto text-center flex-auto content-center'>
            <h1>
                {tVars('helloName', 'Hola {{employeeName}}', { employeeName: user?.Employee?.fullname_short })}
            </h1>
            <CustomError textError={t('CantAccesToTpvBecauseNoWorkingCenters', 'No puedes acceder al TPV debido a que no tienes centro de trabajo')} />
        </div>
    )
}

const mapTPVDashboardConnector = (state: AllReduxAppPayloads) => ({ EmployeeWorkingCenterId: state.user?.extraData?.WorkingCenterId, EmployeeWorkingCenterStationId: state.user?.extraData?.WorkingCenterStationId, dateLastChange: state.user?.dateLastChange, subTypeUser: state.user?.subType })
export const TPVDashboardConnector = connect(mapTPVDashboardConnector, null, null, { context: GlobalContext })
export type ReduxTPVDashboardConnector = ConnectedProps<typeof TPVDashboardConnector>


export default TPVDashboardConnector(TPVDashboard)
